module.exports = __webpack_public_path__ + "img/dinner.c58217d0.svg";